(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[58],{

/***/ 3199:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tests/create",
      function () {
        return __webpack_require__(9152);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 8653:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(414);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);





var Authenticated = function(param) {
    var requiredRole = param.requiredRole, children = param.children;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isLoginChecked = ref[0], setIsLoginChecked = ref[1];
    var isVerifyingStarted = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(false);
    var redirectToLogin = function(locationPathname, authCheckFailed, requiredRole) {
        var query = {
            redirectTo: "".concat(locationPathname).concat(location.search)
        };
        if (authCheckFailed) {
            query.authCheckFailed = authCheckFailed;
        }
        if (requiredRole) {
            query.requiredRole = requiredRole;
        }
        router.push({
            pathname: "/login",
            query: query
        });
    };
    var verifyLogin = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
            var rawLocationPathname, locationPathname, accessToken, authResponce, authResult, userPayload;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        rawLocationPathname = location.pathname;
                        locationPathname = rawLocationPathname.startsWith("/") ? rawLocationPathname : "/" + rawLocationPathname;
                        accessToken = localStorage.getItem("accessToken");
                        if (!accessToken || accessToken == "null" || accessToken == "undefined") {
                            return [
                                2,
                                redirectToLogin(locationPathname)
                            ];
                        }
                        return [
                            4,
                            fetch("/api/v1/auth/verify?token=".concat(accessToken))
                        ];
                    case 1:
                        authResponce = _state.sent();
                        if (!authResponce.ok) {
                            return [
                                2,
                                redirectToLogin(locationPathname, true)
                            ];
                        }
                        return [
                            4,
                            authResponce.json()
                        ];
                    case 2:
                        authResult = _state.sent();
                        if (!authResult.data.verified) {
                            redirectToLogin(locationPathname);
                        } else {
                            userPayload = authResult.data.payload;
                            if (requiredRole !== undefined && userPayload.role < requiredRole) {
                                redirectToLogin(locationPathname, false, requiredRole);
                            }
                        }
                        setIsLoginChecked(true);
                        return [
                            2
                        ];
                }
            });
        });
        return function verifyLogin() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (!isVerifyingStarted.current) {
            isVerifyingStarted.current = true;
            verifyLogin();
        }
    }, [
        router,
        requiredRole
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: isLoginChecked && children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Authenticated);


/***/ }),

/***/ 9500:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7568);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(414);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _types_dialog_interface__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3366);
/* harmony import */ var _styles_Dialog_module_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7940);
/* harmony import */ var _styles_Dialog_module_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_Dialog_module_css__WEBPACK_IMPORTED_MODULE_3__);







var styles = (_styles_Dialog_module_css__WEBPACK_IMPORTED_MODULE_3___default());
var Dialog = function(param) {
    var title = param.title, description = param.description, opened = param.opened, dismissable = param.dismissable, type = param.type, inputs = param.inputs, enableTogglingKeypresses = param.enableTogglingKeypresses, confirmButtonName = param.confirmButtonName, cancelButtonName = param.cancelButtonName, className = param.className, descriptionHTML = param.descriptionHTML, onClose = param.onClose, children = param.children;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(opened), isOpen = ref[0], setIsOpen = ref[1];
    description = description || "";
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        setIsOpen(opened);
        opened ? document.body.classList.add("dialog-opened") : document.body.classList.remove("dialog-opened");
        var handleKeypress = function(e) {
            if (enableTogglingKeypresses) {
                if (e.key == "Enter") {
                    handleClose(true, inputs);
                }
                if (e.key == "Escape") {
                    handleClose(false, {});
                }
                document.addEventListener("keydown", handleKeypress);
            }
        };
        if (enableTogglingKeypresses) {
            return function() {
                document.removeEventListener("keydown", handleKeypress);
            };
        }
    }, [
        opened
    ]);
    var parseMarkdownString = function(input) {
        var boldRegex = /\*\*(.*?)\*\*/g;
        var italicRegex = /\*(.*?)\*/g;
        var underlineRegex = /__(.*?)__/g;
        var result = input.replaceAll(boldRegex, "<b>$1</b>").replaceAll(italicRegex, "<em>$1</em>").replaceAll(underlineRegex, "<u>$1</u>");
        return result;
    };
    var parseMarkdown = function(input) {
        var joinedString = input.map(function(element) {
            return element.props.children;
        }).join("");
        var result = parseMarkdownString(joinedString);
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            dangerouslySetInnerHTML: {
                __html: result
            }
        });
    };
    var descriptionLines = description.split("\n");
    var descriptionWithLineBreaks = descriptionLines.map(function(line, index) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
            children: [
                parseMarkdown([
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: line
                    })
                ]),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {})
            ]
        }, index);
    });
    var getConfirmationButtons = function() {
        switch(type){
            case _types_dialog_interface__WEBPACK_IMPORTED_MODULE_2__/* .DialogType.INFO */ .i.INFO:
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                    className: styles["submit-button"],
                    onClick: function() {
                        return handleClose(true, inputs);
                    },
                    children: cancelButtonName || "ОК"
                });
            case _types_dialog_interface__WEBPACK_IMPORTED_MODULE_2__/* .DialogType.QUESTION */ .i.QUESTION:
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            className: styles["submit-button"],
                            onClick: function() {
                                return handleClose(true, inputs);
                            },
                            children: confirmButtonName || "Да"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            className: styles["cancel-button"],
                            onClick: function() {
                                return handleClose(false, {});
                            },
                            children: cancelButtonName || "Нет"
                        })
                    ]
                });
            case _types_dialog_interface__WEBPACK_IMPORTED_MODULE_2__/* .DialogType.SUBMIT */ .i.SUBMIT:
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                    className: styles["submit-button"],
                    onClick: function() {
                        return handleClose(true, inputs);
                    },
                    children: confirmButtonName || "Отправить"
                });
            case _types_dialog_interface__WEBPACK_IMPORTED_MODULE_2__/* .DialogType.SUBMIT_WITH_CANCEL */ .i.SUBMIT_WITH_CANCEL:
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            className: styles["submit-button"],
                            onClick: function() {
                                return handleClose(true, inputs);
                            },
                            children: confirmButtonName || "Отправить"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            className: styles["cancel-button"],
                            onClick: function() {
                                return handleClose(false, {});
                            },
                            children: cancelButtonName || "Отмена"
                        })
                    ]
                });
            case _types_dialog_interface__WEBPACK_IMPORTED_MODULE_2__/* .DialogType.NONE */ .i.NONE:
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
        }
    };
    var handleClose = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(confirmed, inputs) {
            var ref, handlingResult, toClose;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!onClose) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            Promise.all([
                                onClose(confirmed, inputs || {})
                            ])
                        ];
                    case 1:
                        ref = _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"].apply */ .Z.apply(void 0, [
                            _state.sent(),
                            1
                        ]), handlingResult = ref[0];
                        toClose = handlingResult == undefined ? true : handlingResult;
                        if (toClose || !confirmed) {
                            setIsOpen(false);
                        }
                        return [
                            3,
                            3
                        ];
                    case 2:
                        setIsOpen(false);
                        _state.label = 3;
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleClose(confirmed, inputs) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: isOpen && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "".concat(styles.dialog).concat(className ? " " + className : ""),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: styles.content,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: styles["dialog-info"],
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                    children: title
                                }),
                                description ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    children: descriptionHTML ? "" : descriptionWithLineBreaks
                                }) : descriptionHTML ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    dangerouslySetInnerHTML: {
                                        __html: descriptionHTML
                                    }
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {})
                            ]
                        }),
                        children,
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: styles.actions,
                            children: getConfirmationButtons()
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: styles.overlay,
                    onClick: dismissable ? function() {
                        return handleClose(false, {});
                    } : undefined
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Dialog);


/***/ }),

/***/ 6448:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "bo": function() { return /* binding */ userRolesInRussian; },
/* harmony export */   "i4": function() { return /* binding */ UserRole; }
/* harmony export */ });
/* unused harmony export userRoles */
var UserRole;
(function(UserRole) {
    UserRole[UserRole["USER"] = 0] = "USER";
    UserRole[UserRole["MODERATOR"] = 1] = "MODERATOR";
    UserRole[UserRole["ADMIN"] = 2] = "ADMIN";
})(UserRole || (UserRole = {}));
var userRoles = (/* unused pure expression or super */ null && ([
    "User",
    "Moderator",
    "Admin"
]));
var userRolesInRussian = [
    "Пользователь",
    "Модератор",
    "Админитратор"
];


/***/ }),

/***/ 9152:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(7568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(414);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var nprogress__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4865);
/* harmony import */ var nprogress__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(nprogress__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _components_Dialog__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9500);
/* harmony import */ var _components_Authenticated__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8653);
/* harmony import */ var _types_dialog_interface__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3366);
/* harmony import */ var _lib_user__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(6448);
/* harmony import */ var _styles_Form_module_css__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(7049);
/* harmony import */ var _styles_Form_module_css__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_styles_Form_module_css__WEBPACK_IMPORTED_MODULE_8__);











var styles = (_styles_Form_module_css__WEBPACK_IMPORTED_MODULE_8___default());
var Page = function() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(""), testCreationError = ref[0], setTestCreationError = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(""), title = ref1[0], setTitle = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(""), description = ref2[0], setDescription = ref2[1];
    var handleTitleInputChange = function(e) {
        setTitle(e.target.value);
    };
    var handleDescriptionInputChange = function(e) {
        setDescription(e.target.value);
    };
    var handleClose = function(confirmed) {
        if (!confirmed) {
            return router.push({
                pathname: "/tests/created"
            });
        }
        (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(function() {
            var accessToken, responce, result;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (false) {}
                        accessToken = localStorage.getItem("accessToken") || "";
                        nprogress__WEBPACK_IMPORTED_MODULE_3___default().start();
                        return [
                            4,
                            fetch("/api/v1/tests/create", {
                                method: "PUT",
                                body: JSON.stringify({
                                    title: title,
                                    description: description
                                }),
                                headers: {
                                    authorization: accessToken
                                }
                            })
                        ];
                    case 1:
                        responce = _state.sent();
                        if (!responce.ok) {
                            switch(responce.status){
                                case 401:
                                    {
                                        return [
                                            2,
                                            setTestCreationError("Войдите в систему для выполнения данного действия.")
                                        ];
                                    }
                                case 403:
                                    {
                                        return [
                                            2,
                                            setTestCreationError("У вас нет прав на это действие.")
                                        ];
                                    }
                                case 429:
                                    {
                                        return [
                                            2,
                                            setTestCreationError("Вы отправляете слишком много запросов.")
                                        ];
                                    }
                                default:
                                    {
                                        return [
                                            2,
                                            setTestCreationError("Не удалось создать тест.")
                                        ];
                                    }
                            }
                        }
                        return [
                            4,
                            responce.json()
                        ];
                    case 2:
                        result = _state.sent();
                        return [
                            2,
                            router.push({
                                pathname: "/tests/edit",
                                query: {
                                    id: "".concat(result.data.test.id)
                                }
                            })
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })().then(function() {
            nprogress__WEBPACK_IMPORTED_MODULE_3___default().done();
        });
    };
    var handleErrorDialogClose = function() {
        return router.push({
            pathname: "/tests/created"
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_Authenticated__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            requiredRole: _lib_user__WEBPACK_IMPORTED_MODULE_7__/* .UserRole.USER */ .i4.USER,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Dialog__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    opened: true,
                    title: "Создание теста",
                    description: "Укажите первоначальную информацию о вашем будущем тесте.",
                    dismissable: false,
                    type: _types_dialog_interface__WEBPACK_IMPORTED_MODULE_6__/* .DialogType.SUBMIT_WITH_CANCEL */ .i.SUBMIT_WITH_CANCEL,
                    onClose: handleClose,
                    confirmButtonName: "Создать тест",
                    cancelButtonName: "Отмена",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: styles.form,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                        className: styles.label,
                                        children: "Название теста"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                        className: styles.input,
                                        type: "text",
                                        onChange: handleTitleInputChange,
                                        placeholder: "Название теста"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                        className: styles.label,
                                        children: "Описание"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                        className: styles.input,
                                        type: "text",
                                        onChange: handleDescriptionInputChange,
                                        placeholder: "Описание теста"
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Dialog__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    opened: !!testCreationError,
                    title: "Ошибка",
                    description: testCreationError,
                    dismissable: false,
                    type: _types_dialog_interface__WEBPACK_IMPORTED_MODULE_6__/* .DialogType.INFO */ .i.INFO,
                    onClose: handleErrorDialogClose
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Page);


/***/ }),

/***/ 3366:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ DialogType; }
/* harmony export */ });
var DialogType;
(function(DialogType) {
    DialogType[DialogType["INFO"] = 0] = "INFO";
    DialogType[DialogType["QUESTION"] = 1] = "QUESTION";
    DialogType[DialogType["SUBMIT"] = 2] = "SUBMIT";
    DialogType[DialogType["SUBMIT_WITH_CANCEL"] = 3] = "SUBMIT_WITH_CANCEL";
    DialogType[DialogType["NONE"] = 4] = "NONE";
})(DialogType || (DialogType = {}));


/***/ }),

/***/ 7940:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"dialog":"Dialog_dialog__THu6o","content":"Dialog_content__t2syO","dialog-info":"Dialog_dialog-info__j1_UR","actions":"Dialog_actions__xMAgR","overlay":"Dialog_overlay__Hu_IV","submit-button":"Dialog_submit-button__SVCAU","processing":"Dialog_processing__YZfAM","cancel-button":"Dialog_cancel-button__d8uJf","dialog-close":"Dialog_dialog-close__mHTeh"};

/***/ }),

/***/ 7049:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"Form_container__uIRNh","main":"Form_main__a16Zp","form":"Form_form__sAxPa","title":"Form_title__OVe54","input":"Form_input__aosMq","label":"Form_label__kp_zC","button":"Form_button__nEJkr","processing":"Form_processing__E9c2z","spaced-button":"Form_spaced-button___HnEb","link":"Form_link__2o5rA","link-blue":"Form_link-blue__vbuZt","error":"Form_error__QpMMq","notice":"Form_notice__JEFlo","checkboxes":"Form_checkboxes__vb7f_","checkbox-container":"Form_checkbox-container__fhI2B","info-entry":"Form_info-entry__Y6_2i","danger-button":"Form_danger-button__K3RRj","info":"Form_info__bCF4i","block":"Form_block__NQxSk","text-input":"Form_text-input__5Lr3w"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,888,179], function() { return __webpack_exec__(3199); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);